module.exports = __webpack_public_path__ + "img/blueBar.2cbb3490.webp";